import React, { FC, useState } from 'react';

import {
    Spacer,
    Modal
} from '@components/1-atoms';

import {
    AppTemplate
} from '@components/4-templates';

import {
    PageHeader,
    IconButton
} from '@components/2-molecules';

import {
    ProductServiceList, ProductsServicesMenu
} from '@components/3-organisms';

import { STATE, initialValue } from '@lib/constants';
import { useProductsServices } from '@lib/hooks/useProductService';


import { ForwardedPageProps } from '@lib/constants';
import Sandwich from '@assets/icons/sandwich';
import Add from '@assets/icons/plus';

const ProductOfService: FC<ForwardedPageProps> = ({ navigation, ...props }) => {

    const [productsOrServices] = useProductsServices({ /* id: data.id, */ message: 'Loading...', state: STATE.READY });

    return (
        <AppTemplate hooks={[productsOrServices]} >

            <PageHeader
                title={"PRODUCTS AND SERVICES"}
                left={<IconButton icon={<Sandwich />} onPress={navigation?.toggleDrawer} />}
                menu={<ProductsServicesMenu navigation={navigation} />}
                menuIcon={<Add />}
            />
            <Spacer h={1} />

            <Spacer h={2} />
            <ProductServiceList
                color={productsOrServices?.data?.length ? '#000' : '#FFF'}
                data={productsOrServices.data}
            />

        </AppTemplate>
    );
};


import { withForwardedNavigationParams } from 'react-navigation-props-mapper';
export default withForwardedNavigationParams<ForwardedPageProps>()(ProductOfService);